import React, { PropTypes } from 'react';
import Dialog, {  } from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { FormattedMessage } from 'react-intl';

class ConfirmMessage extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    label: PropTypes.node.isRequired,
    message: PropTypes.node,
    cancelButtonText: PropTypes.node,
    confirmButtonText: PropTypes.node,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
  };

  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired
  };

  getStyle() {
    const {
            baseTheme
          } = this.context.muiTheme;

    const gutter = baseTheme.spacing.desktopGutter;

    return {
      title: {
        margin: 0,
        padding: `${gutter}px ${gutter}px 0 ${gutter}px`,
        color: baseTheme.palette.textColor,
        fontSize: 24,
        lineHeight: '32px',
        fontWeight: 400
      }
    }
  }

  confirm() {
    this.props.onConfirm();
    this.handleClose();
  }

  handleClose() {
    this.props.onClose();
  }

  render() {
    let { label, message, cancelButtonText, confirmButtonText } = this.props;
    const style = this.getStyle();

    let actions = [
      <FlatButton secondary={true} onClick={() => this.handleClose()}>{cancelButtonText}</FlatButton>,
      <FlatButton primary={true}
                  keyboardFocused={true}
                  onTouchTap={() => this.confirm()}>
        {confirmButtonText}
      </FlatButton>
    ];

    return (
      <Dialog
        title={<h3 style={style.title}>{label}</h3>}
        actions={actions}
        modal={false}
        open={this.props.open}
        onRequestClose={() => this.handleClose()}
      >
        {message}
      </Dialog>
    );
  }
}

ConfirmMessage.defaultProps = {
  cancelButtonText: (<FormattedMessage id="common.cancel" defaultMessage="Cancel"/>),
  confirmButtonText: (<FormattedMessage id="common.confirm" defaultMessage="Confirm"/>)
};

export default ConfirmMessage;




// WEBPACK FOOTER //
// ./src/components/ConfirmMessage.jsx